<template>
  <div class="details-view">
    <div class="main-content hrSetting">
      <div class="section form-column">
        <el-form style="flex-direction: row;">
          <el-form-item style="margin-bottom: 15px!important;">
            <el-button v-if="!isEdit" type="primary" @click="editHandler">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <el-button v-if="isEdit" type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
            <el-button type="primary" @click="refreshHandler">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
          </el-form-item>
          <span style="font-size:14px; margin-left: 20px; font-weight: bold;">{{ $t('PillReport.SetJudgmentCriteria') }}</span>
          <el-form-item>
            <el-checkbox-group v-model="selectedList">
              <el-checkbox
                v-for="(item, index) in settings"
                :key="index"
                :label="item.seqNo"
                :disabled="disabled(item)"
                style="display: block; width: 180px; padding-top: 5px; margin-left: 60px"
              >{{ item.fieldLabel }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { queryPillDataTypeSetting, savePillDataTypeSetting } from '@/api/clearing/pillReport'

export default {
  name: 'TabHrSetting',
  props: { },
  data() {
    return {
      loading: false,
      settings: [],
      selectedList: [],
      isEdit: false
    }
  },
  created() {
    this.refreshHandler()
  },
  methods: {
    // 选中
    setSettings(val) {
      this.settings = val
      this.selectedList = []
      for (const item of this.settings) {
        if (item.valid) this.selectedList.push(item.seqNo)
      }
      console.log('selectedList', this.selectedList)
    },
    refreshHandler() {
      this.isEdit = false
      this.loading = getLoading()
      queryPillDataTypeSetting({ classType: 'HR' }).then(res => {
        this.setSettings(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    editHandler() {
      this.isEdit = true
    },
    // 保存
    saveHandler() {
      this.isEdit = false
      // 是否选中
      for (const item of this.settings) {
        const oldValue = item.valid
        item.valid = this.selectedList.indexOf(item.seqNo) !== -1
        item.changed = item.valid !== oldValue
      }
      this.loading = getLoading()
      savePillDataTypeSetting(this.settings).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.setSettings(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 是否可以取消勾选
    disabled(setting) {
      return true
    }
  }
}
</script>

<style lang="scss">

</style>
